import React, { useEffect, useState } from 'react';
import { FaExternalLinkAlt, FaArrowRight } from 'react-icons/fa';

const HIGHLIGHTS = [
    'Layout, cores, textos e imagens são totalmente personalizáveis.',
    'Stock, serviços e contactos podem ser ligados aos dados reais do stand.',
    'Esta versão serve apenas para validar direção criativa e experiência de utilização.',
];

const DemoDisclaimerModal = () => {
    const [isOpen, setIsOpen] = useState(true);

    useEffect(() => {
        if (!isOpen) return undefined;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[500] flex items-center justify-center p-4 sm:p-6"
            role="dialog"
            aria-modal="true"
            aria-labelledby="demo-modal-title"
        >
            <button
                type="button"
                aria-label="Fechar aviso"
                onClick={() => setIsOpen(false)}
                className="absolute inset-0 bg-black/80 backdrop-blur-md border-0 cursor-pointer animate-fade-in"
            />

            <div className="relative w-full max-w-lg bg-[#0a0a0a] border border-white/[0.08] shadow-[0_0_80px_rgba(206,188,82,0.12)] animate-fade-up overflow-hidden">
                <div className="h-[3px] w-full bg-gradient-to-r from-transparent via-red to-transparent" />
                <div className="ajp-grain absolute inset-0 pointer-events-none opacity-60" />

                <div className="relative z-10 p-7 sm:p-9">
                    <p className="section-tag mb-5">Demonstração</p>

                    <h2 id="demo-modal-title" className="font-display text-3xl sm:text-4xl text-white tracking-wide leading-none mb-4">
                        VERSÃO DE<br />
                        <span className="text-gradient">DEMONSTRAÇÃO</span>
                    </h2>

                    <p className="text-white/55 text-sm leading-relaxed mb-6">
                        Este website foi desenvolvido pela{' '}
                        <a
                            href="https://www.samworks.online"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-red font-semibold hover:text-white transition-colors inline-flex items-center gap-1"
                        >
                            Samworks
                            <FaExternalLinkAlt size={9} />
                        </a>{' '}
                        como proposta visual para a <strong className="text-white/80 font-semibold">Auto João Pires</strong>.
                        Trata-se de uma tentativa de aproximação aos standards da marca — não é o site final oficial.
                    </p>

                    <ul className="space-y-3 mb-8">
                        {HIGHLIGHTS.map((item) => (
                            <li key={item} className="flex gap-3 text-sm text-white/45 leading-relaxed">
                                <span className="text-red shrink-0 mt-0.5">◆</span>
                                <span>{item}</span>
                            </li>
                        ))}
                    </ul>

                    <div className="flex flex-col sm:flex-row gap-3">
                        <button
                            type="button"
                            onClick={() => setIsOpen(false)}
                            className="btn-primary flex-1 justify-center"
                        >
                            Explorar demonstração
                            <FaArrowRight size={10} />
                        </button>
                        <a
                            href="https://www.samworks.online"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-secondary flex-1 justify-center text-center"
                        >
                            samworks.online
                        </a>
                    </div>

                    <p className="text-[10px] text-white/20 uppercase tracking-[0.2em] text-center mt-6">
                        © Samworks · Proposta demonstrativa
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DemoDisclaimerModal;
